import { render, staticRenderFns } from "./Hierarchy.vue?vue&type=template&id=4387f1ba&scoped=true&"
import script from "./Hierarchy.vue?vue&type=script&lang=js&"
export * from "./Hierarchy.vue?vue&type=script&lang=js&"
import style0 from "./Hierarchy.vue?vue&type=style&index=0&id=4387f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387f1ba",
  null
  
)

export default component.exports